/* eslint-disable */
export default function([...values]) {
    return values
        .filter(v =>
            v !== null &&
            v !== undefined &&
            v !== ''
        )
        .length === values.length;
}